export type JournalLeaveSnapshot = {
  title: string;
  contentMd: string;
  contentHtml: string | null;
};

function plainHtml(html: string | null | undefined): string {
  return (html ?? '')
    .replace(/<[^>]+>/g, '')
    .replace(/&nbsp;/gi, ' ')
    .trim();
}

/**
 * True when the open note differs from the last explicit Gem.
 * An empty editor paragraph does not count, and a prefilled title alone does not count.
 */
export function journalLeaveDirty(input: {
  title: string;
  contentMd: string;
  contentHtml: string | null;
  pendingFileCount: number;
  saved: JournalLeaveSnapshot;
  prefilledTitle?: string;
}): boolean {
  if (input.pendingFileCount > 0) return true;
  const title = input.title.trim();
  const savedTitle = input.saved.title.trim();
  const content = input.contentMd.trim();
  const savedContent = input.saved.contentMd.trim();
  if (content !== savedContent) return true;

  const html = (input.contentHtml ?? '').trim();
  const savedHtml = (input.saved.contentHtml ?? '').trim();
  const htmlEmpty = plainHtml(html).length === 0;
  const savedHtmlEmpty = plainHtml(savedHtml).length === 0;
  if ((!htmlEmpty || !savedHtmlEmpty) && html !== savedHtml) return true;

  if (title === savedTitle) return false;
  const prefilled = (input.prefilledTitle ?? '').trim();
  if (
    !savedTitle &&
    !savedContent &&
    savedHtmlEmpty &&
    !content &&
    htmlEmpty &&
    title === prefilled
  ) {
    return false;
  }
  return title !== savedTitle;
}
